import { SlideAnimationContext } from "contexts/SlideAnimation";
import { useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { OrganizationVaProfile } from "schemas/dashboard";
import { Map } from "schemas/functions";
import { routes } from "schemas/routes";

import ConversationalTemplate from "features/Auth/Onboarding/ConversationalTemplate";
import { makeDeepCopy } from "utils/updateLocalState";

interface Props {
  organizationVaProfile: OrganizationVaProfile | null;
  saveOrgVaProfile: (
    organizationVaProfile: OrganizationVaProfile,
    excludeIncludeFiltersChange?: boolean,
    moveNext?: boolean,
  ) => void;
}

const BentoConvo = ({ organizationVaProfile, saveOrgVaProfile }: Props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const slideContext = useContext(SlideAnimationContext);

  const handleBack = async () => {
    if (slideContext) {
      await slideContext.slideOutDown();
      slideContext.slideInDown();
    }
    navigate(
      `/${routes.templatesMethodSelfServeOnboarding}/${location.search}`,
    );
  };

  const handleNext = async (updatedForm?: Map) => {
    if (!updatedForm || !updatedForm.outreach) return;

    const copy = makeDeepCopy(organizationVaProfile || {});
    copy.fallbackTemplateIds = [updatedForm.outreach.id];
    if (updatedForm.followup) {
      copy.fallbackTemplateIds.push(updatedForm.followup.id);
    }
    saveOrgVaProfile(copy, false, false);
    if (slideContext) {
      await slideContext.slideOutUp();
      slideContext.slideInUp();
    }
    navigate(`/${routes.faqSelfServeOnboarding}${location.search}`);
  };

  return (
    <ConversationalTemplate handleBack={handleBack} handleNext={handleNext} />
  );
};

export default BentoConvo;
